import { createSelector } from 'reselect';
import { refreshObject } from '%paysera_seat_selection/js/seatSelection/redux/component/orm/selectors';

export default createSelector(
    state => state.seat_selection.workflow.selection,
    state => state,
    ({ objects }, state) => objects
        .map(object => refreshObject(state, object))
        .filter(object => object !== null),
);
